import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useQuery } from "@apollo/client";
import { Outlet } from "react-router-dom";
//Import from project
import "./layout.scss";
import { Menu } from "./Menu/Menu";
import { AuthContext } from "../Context/AuthContext";
import { GET_USER_LOGIN } from "../Schema/User";

const drawerWidth = 245;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

export default function Layout() {
  // let location = useLocation();
  const navigate = useNavigate();

  const { dispatch } = useContext(AuthContext);

  const [open, setOpen] = useState(true);

  //============================ get user login =================================
  const { refetch } = useQuery(GET_USER_LOGIN, {
    pollInterval: 1000,
    onCompleted: ({ getUserLogin }) => {
      // setWidth(window.innerWidth);
      if (!getUserLogin?.user) {
        window.localStorage.removeItem("userLogin");
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("role");
        dispatch({
          type: "LOGGED_IN_USER",
          payload: null,
        });
        window.location.reload(false);
        navigate("/login");
      }
    },
    onError: (error) => {
      console.log("error::", error);
      // setWidth(window.innerWidth);
      let result =
        error.message.includes("Unauthorized!") ||
        error.message.includes("Your session expired!");
      if (result) {
        window.localStorage.removeItem("userLogin");
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("role");
        dispatch({
          type: "LOGGED_IN_USER",
          payload: null,
        });
        window.location.reload(false);
        navigate("/login");
      }
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="layout-container">
      <Menu />
      <Main open={open} className="outlet-container">
        <Outlet />
      </Main>
    </div>
  );
}
